import { Component, Input, OnInit, HostListener, ChangeDetectionStrategy, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CITIES } from '@utils/constants/constant';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    // RouterLink
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() showTitle: boolean = false;
  public showMenu: boolean = false;
  public showMenuCities: boolean = false;
  public showCitiesMenu: boolean = false;

  public isMobile: boolean = false;

  private resizeTimer: any;

  cities = CITIES;
  cityKeys = Object.keys(CITIES);

  isCityPage = false;
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.checkIfMobile();

    // Initial check
    this.checkRoute(this.router.url);

    // Listen to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.checkRoute(event.urlAfterRedirects);
      this.cdr.markForCheck(); // Since we use OnPush change detection
    });
  }

  private checkRoute(url: string) {
    const cleanUrl = url.split('?')[0].split('#')[0].replace(/^\/|\/$/g, '');
    this.isCityPage = this.cityKeys.some(key => this.cities[key].url === cleanUrl);
  }

  @HostListener('window:resize')
  onResize(): void {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => this.checkIfMobile(), 150);
  }

  public isAnyMenuOpen(): boolean {
    return this.showMenu || this.showMenuCities;
  }

  public closeAllMenus(): void {
    this.showMenu = false;
    this.showMenuCities = false;
    this.showCitiesMenu = false;
    this.lockBodyScroll(false);
  }

  public toggleMenu(): void {
    const wasOpen = this.showMenu;
    this.closeAllMenus();
    this.showMenu = !wasOpen;
    this.lockBodyScroll(this.showMenu);
  }

  public toggleMenuCities(): void {
    const wasOpen = this.showMenuCities;
    this.closeAllMenus();
    this.showMenuCities = !wasOpen;
    this.lockBodyScroll(this.showMenuCities);
  }

  public toggleCitiesMenu(): void {
    this.showCitiesMenu = !this.showCitiesMenu;
  }

  private checkIfMobile(): void {
    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 850;
    }
  }

  private lockBodyScroll(lock: boolean): void {
    if (typeof document !== 'undefined') {
      if (lock) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  }

  public closeMenu(): void {
    this.showMenu = false;
    this.showMenuCities = false;
    this.showCitiesMenu = false;
    this.lockBodyScroll(false);
  }
}
